var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDynamicAud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4AA59C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6627 5.82982L12.5027 6.66982L10.8227 8.34982L11.651 9.17815L13.331 7.49815L14.171 8.33815C14.3518 8.51898 14.6668 8.39065 14.6668 8.12815V5.62565C14.6668 5.46232 14.5385 5.33398 14.3752 5.33398H11.8727C11.6102 5.33398 11.4818 5.64898 11.6627 5.82982ZM8.12766 5.33398H5.62516C5.46183 5.33398 5.3335 5.46232 5.3335 5.62565V8.12815C5.3335 8.39065 5.6485 8.51898 5.82933 8.33232L6.66933 7.49232L9.41683 10.234V14.084C9.41683 14.4048 9.67933 14.6673 10.0002 14.6673C10.321 14.6673 10.5835 14.4048 10.5835 14.084V10.0007C10.5835 9.84898 10.5193 9.69732 10.4143 9.58648L7.49766 6.66398L8.33766 5.82398C8.5185 5.64898 8.39016 5.33398 8.12766 5.33398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicAud);
export default __webpack_public_path__ + "static/media/dynamic_aud.64514c93ce313f539a398d59105fe0e1.svg";
export { ForwardRef as ReactComponent };